import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DownloadParcelLabelMutationVariables = Types.Exact<{
  order_id: Types.Scalars['UUID'];
  parcel_id: Types.Scalars['String'];
}>;


export type DownloadParcelLabelMutation = { __typename?: 'Mutation', downloadParcelLabel: { __typename?: 'DownloadParcelLabelResult', label_url: string, parcel_id: string, tracking_number?: string | null } };


export const DownloadParcelLabelDocument = gql`
    mutation DownloadParcelLabel($order_id: UUID!, $parcel_id: String!) {
  downloadParcelLabel(order_id: $order_id, parcel_id: $parcel_id) {
    label_url
    parcel_id
    tracking_number
  }
}
    `;
export type DownloadParcelLabelMutationFn = Apollo.MutationFunction<DownloadParcelLabelMutation, DownloadParcelLabelMutationVariables>;

/**
 * __useDownloadParcelLabelMutation__
 *
 * To run a mutation, you first call `useDownloadParcelLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadParcelLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadParcelLabelMutation, { data, loading, error }] = useDownloadParcelLabelMutation({
 *   variables: {
 *      order_id: // value for 'order_id'
 *      parcel_id: // value for 'parcel_id'
 *   },
 * });
 */
export function useDownloadParcelLabelMutation(baseOptions?: Apollo.MutationHookOptions<DownloadParcelLabelMutation, DownloadParcelLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadParcelLabelMutation, DownloadParcelLabelMutationVariables>(DownloadParcelLabelDocument, options);
      }
export type DownloadParcelLabelMutationHookResult = ReturnType<typeof useDownloadParcelLabelMutation>;
export type DownloadParcelLabelMutationResult = Apollo.MutationResult<DownloadParcelLabelMutation>;
export type DownloadParcelLabelMutationOptions = Apollo.BaseMutationOptions<DownloadParcelLabelMutation, DownloadParcelLabelMutationVariables>;